import { Controller } from "@hotwired/stimulus"

// Renders a timestamp in the user's local timezone using Intl.DateTimeFormat
// Usage:
// <time data-controller="local-time" data-local-time-iso-value="2025-08-18T06:59:08Z"></time>
// Optional: data-local-time-format-value ("short" | "medium" | "long")
export default class extends Controller {
  static values = {
    iso: String,
    format: { type: String, default: "medium" }
  }

  connect() {
    try {
      const iso = this.isoValue || this.element.getAttribute("datetime") || this.element.textContent
      if (!iso) return
      const d = new Date(iso)
      if (isNaN(d.getTime())) return

      const style = this.formatValue
      const opts = this.#optionsFor(style)
      const formatted = new Intl.DateTimeFormat(undefined, opts).format(d)
      const full = new Intl.DateTimeFormat(undefined, this.#optionsFor("long")).format(d)

      this.element.textContent = formatted
      this.element.setAttribute("title", full)
      this.element.setAttribute("datetime", d.toISOString())
    } catch (_) {
      // no-op
    }
  }

  #optionsFor(style) {
    switch (style) {
      case "short":
        return { dateStyle: "short", timeStyle: "short" }
      case "long":
        return { dateStyle: "long", timeStyle: "long" }
      case "medium":
        return { dateStyle: "medium", timeStyle: "long" }
      default:
        return { dateStyle: "medium", timeStyle: "short" }
    }
  }
}
